module.exports = __webpack_public_path__ + "static/averta-semibold-a6c3b1add99a5391cb62e6d751f84e2d.woff2";